import React from "react";
const ArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 20}
    height={props?.height || 21}
    viewBox="0 0 20 21"
    fill="none"
    {...props}
  >
    <path
      d="M7.50004 5.5L12.5 10.5L7.5 15.5"
      stroke="#777980"
      strokeWidth={1.5}
      strokeMiterlimit={16}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ArrowRight;
